import {
  Row,
  Col,
  Modal,
  Form,
  Input,
  DatePicker,
  InputNumber,
  Radio,
} from "antd";
import moment from "moment";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";

const AddFrom = ({ path, sectionName, show, hide, data, refresh }) => {
  const api = {
    discount: apiPath.addEditDiscount,
  };
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [startDate, setStartDate] = useState(null);
  const [discountType, setDiscountType] = useState("flat");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      ...data,
      description: data.description,
      startDate: moment(data.start_date),
      endDate: moment(data.end_date),
      image: [{ url: data.image }],
    });
  }, [data]);

  const onCreate = (values) => {
    const {
      name,
      startDate,
      endDate,
      code,
      type,
      discount,
      description,
      image,
    } = values;

    const payload = {
      name,
      startDate,
      endDate,
      code,
      type,
      discount,
      description,
      image: image && image.length > 0 ? image[0].url : "",
    };

    setLoading(true);

    const url = data?._id ? `${api.discount}/${data._id}` : api.discount;
    const method = data?._id ? "POST" : "POST";

    request({
      url,
      method,
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };
  const handleDiscountTypeChange = (e) => {
    setDiscountType(e.target.value);
    console.log("Discount type changed---", setDiscountType(e.target.value));
  };

  const disabledStartDate = (current) => {
    return current && current < moment().startOf("day"); // Disable past dates
  };

  // Disable dates for the end date that are earlier than the selected start date
  const disabledEndDate = (current) => {
    return startDate
      ? current && current < moment(startDate).endOf("day")
      : false;
  };

  return (
    <Modal
      width={1100}
      open={show}
      title={`${data
        ? lang("Update") + " " + sectionName
        : lang("Add") + " " + lang("New") + " " + sectionName
        }`}
      okText={`${data ? lang("Update") : lang("Add")}`}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: "8px" }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="create"
        form={form}
        initialValues={{ deal_in: "Products" }}
        onFinish={onCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} lg={8}>
            <Form.Item
              label="Enter Start Date"
              name="startDate"
              rules={[
                {
                  required: true,
                  message: "Please Enter Start Date",
                },
              ]}
            >
              <DatePicker
                onChange={(date) => setStartDate(date)}
                disabledDate={disabledStartDate}
              />
            </Form.Item>
          </Col>

          {/* End Date Picker */}
          <Col span={24} sm={12} lg={8}>
            <Form.Item
              label="Enter End Date"
              name="endDate"
              rules={[
                {
                  required: true,
                  message: "Please Enter End Date",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (
                      !value ||
                      moment(value).isSameOrAfter(getFieldValue("startDate"))
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("End Date cannot be before Start Date!")
                    );
                  },
                }),
              ]}
            >
              <DatePicker disabledDate={disabledEndDate} />
            </Form.Item>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <Form.Item
              className="mb-1"
              label={"Discount Code"}
              name="code"
              rules={[
                {
                  required: true,
                  message: "Please Enter Code",
                },
              ]}
            >
              <Input
                placeholder="Enter code"
                onChange={(e) =>
                  form.setFieldsValue({ code: e.target.value.toUpperCase() })
                }
                style={{ textTransform: "uppercase" }} // Display uppercase
              />
            </Form.Item>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <Form.Item
              label="Discount Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please select discount type",
                },
              ]}
            >
              <Radio.Group onChange={handleDiscountTypeChange}>
                <Radio value="flat">Flat</Radio>
                <Radio value="percent">Percent</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24} sm={12} lg={8}>
            <Form.Item
              className="mb-1"
              label={"Discount"}
              name="discount"
              rules={[
                {
                  required: true,
                  message: "Please Enter Discount",
                },
              ]}
            >
              <InputNumber
                min={1}
                placeholder={
                  discountType === "flat"
                    ? "Please Enter Discount(₹)"
                    : "Please Enter Discount(%)"
                }
                addonBefore={discountType === "flat" ? "₹" : "%"}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={24} sm={24}>
            <Form.Item
              className="mb-1"
              label={"Description"}
              name="description"
              rules={[
                {
                  required: true,
                  message: "Please Enter Description",
                },
              ]}
            >
              <Input.TextArea placeholder="Please Enter Description" rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddFrom;
